var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MultiStepDialog',{attrs:{"max-width":"850px","steps":_vm.steps,"scrollable":"","fullscreen":!_vm.isLargeScreen},scopedSlots:_vm._u([{key:"activator",fn:function(data){return [_vm._t("activator",null,null,data)]}}],null,true),model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}})
}
var staticRenderFns = []

export { render, staticRenderFns }